import { useCallback, useEffect, useState } from 'react'
import {
  Backdrop,
  CircularProgress,
  Grid,
  makeStyles,
  Divider,
  Typography,
  Button,
  Dialog,
  DialogContent
} from '@material-ui/core'
import { downloadOrderInvoice, getOrder, uploadOrderInvoice } from '../../api/orders.service'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import { formatDate } from '../../common/utils'
import OrderContentDetail from './OrderContentDetail'
import AcceptOrder from './AcceptOrder'
import FileInputModal from '../../components/Resources/FileInputModal'
import { toast } from 'react-toastify'
import { DialogTitle } from '../../components/DialogTitle'
import { AccessTime } from '@material-ui/icons'

import ChangeProviderAndAcceptDocuments from '../../components/ChangeProviderAndAcceptDocuments'
import { events, pages, sections } from '../../common/activityLog'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  title: {
    justifySelf: 'end',
    margin: '-5px 15px 20px 5px'
  }
}))

const OrderDetails = (props) => {
  const classes = useStyles()

  const orderNumber = props.orderNumber
  const level = props.level
  const handleClose = props.onClose
  const deliveryOrder = props.deliveryOrder

  const [loading, setLoading] = useState(false)
  const [stateForm, setStateForm] = useState({})
  const [isModalAcceptOpen, setIsModalAcceptOpen] = useState(false)
  const [isEmptyOrderModalOpen, setIsEmptyOrderModalOpen] = useState(false)
  const [notFoundError, setNotFoundError] = useState(null)

  const getData = useCallback(() => {
    const headers = deliveryOrder
      ? {
          sectionId: sections.Orders,
          pageId: pages.Delivery,
          eventId: events.ViewDeliveryOrder
        }
      : undefined
    setLoading(true)
    getOrder(orderNumber, level, headers)
      .then((result) => {
        result.state = statusReplace(result.state)
        setStateForm(result.data)
      })
      .catch((error) => {
        if (error.response.status === 404) {
          setNotFoundError({ error: 'Not Found' })
        } else {
          console.error(error)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [orderNumber, level])

  useEffect(() => {
    if (
      orderNumber !== undefined &&
      orderNumber !== null &&
      level !== undefined &&
      level !== null
    ) {
      getData()
    }
  }, [orderNumber, level, getData])

  useEffect(() => {
    if (notFoundError) {
      setIsEmptyOrderModalOpen(true)
    }
  }, [notFoundError])

  const textEmpty = (text) => {
    if (text === undefined || text === null || text === '') {
      return '--'
    }
    return text
  }
  const statusReplace = (text) => {
    if (text === undefined || text === null || text === '') {
      return '--'
    } else if (text === 'Pendiente NO Confirmado') {
      return 'No Confirmado No Entregado'
    } else if (text === 'Pendiente Confirmado') {
      return 'Confirmado No Entregado'
    }
    return text
  }
  const handleUploadFile = async (docto) => {
    setLoading(true)
    await uploadOrderInvoice({
      orderNumber: orderNumber,
      level: level,
      invoiceFileName: docto.fileName,
      invoiceBase64Content: docto.base64Content
    })
      .then(() => {
        toast.success('Factura enviada al departamento de contabilidad')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleDownloadLastInvoice = async () => {
    setLoading(true)
    await downloadOrderInvoice(orderNumber, level)
      .then((resp) => {
        window.open(resp.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const Title = (_) => (
    <h2>
      Pedido: {orderNumber}/{level}
    </h2>
  )

  const handleCloseEmptyOrderModal = () => {
    setIsEmptyOrderModalOpen(false)
    handleClose()
  }

  const canSaveLabel = stateForm.state === 'Pendiente Confirmado'

  const handleSave = () => {
    stateForm.state !== 'Entregado' && stateForm.confirmationDate === null
      ? setIsModalAcceptOpen(true)
      : setIsModalAcceptOpen(false)
  }

  const handleReserve = () => {
    if (canSaveLabel) {
      window.open('https://conway.addingplus.net/login', '_blank')
    }
  }

  return (
    <div>
      <ChangeProviderAndAcceptDocuments differentProviderId={stateForm.providerId} />

      <Grid container direction="column">
        <DialogTitle title={<Title />} />
        <Grid item>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography color="primary" variant="body1" className="text-uppercase">
                Información General:
              </Typography>
              <Divider className="mb-3" />
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Fecha generación pedido
                  </Typography>
                  <Typography variant="body1">
                    {textEmpty(formatDate(stateForm.orderDate))}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Estado
                  </Typography>
                  <Typography variant="body1">{statusReplace(stateForm.state)}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography color="primary" variant="body1" className="text-uppercase">
                Información Envío:
              </Typography>
              <Divider className="mb-3" />
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Fecha de entrega planificada
                  </Typography>
                  <Typography variant="body1">
                    {textEmpty(formatDate(stateForm.plannedDeliveryDate))}
                  </Typography>
                </Grid>
                {stateForm.state === 'Entregado' && (
                  <Grid item xs={12}>
                    <Typography color="primary" variant="body1">
                      Fecha de recepción real
                    </Typography>
                    <Typography variant="body1">
                      {textEmpty(formatDate(stateForm.realReceivingDate))}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Almacén de entrega
                  </Typography>
                  <Typography variant="body1">{textEmpty(stateForm.deliveryWarehouse)}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography color="primary" variant="body1">
                    Método de envío
                  </Typography>
                  <Typography variant="body1">{textEmpty(stateForm.shippingMethod)}</Typography>
                </Grid>
              </Grid>
            </Grid>

            {!!stateForm.lines?.length && (
              <Grid item xs={12}>
                <Typography color="primary" variant="body1" className="text-uppercase">
                  Detalle:
                </Typography>
                <Divider className="mb-3" />
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12}>
                    <OrderContentDetail order={stateForm} />
                  </Grid>
                </Grid>
              </Grid>
            )}

            {handleClose !== undefined && (
              <div className="w-100">
                <div className="d-flex justify-content-end">
                  <div className="ml-0">
                    <div className="d-flex justify-content-end mt-3 mb-3">
                      <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        className={classes.buttonsContainer}
                      >
                        {canSaveLabel && (
                          <Button
                            disabled={loading}
                            variant="contained"
                            color="secondary"
                            onClick={handleReserve}
                          >
                            RESERVA ALMACÉN
                          </Button>
                        )}

                        {(stateForm.state === 'Pendiente NO Confirmado' ||
                          stateForm.state === 'Visualizado') &&
                          stateForm.confirmationDate === null && (
                            <Button
                              disabled={loading}
                              variant="contained"
                              color="secondary"
                              onClick={handleSave}
                            >
                              CONFIRMAR
                            </Button>
                          )}

                        {stateForm.state === 'Entregado' && stateForm.hasInvoice && (
                          <Button
                            style={{ marginRight: '0.5rem' }}
                            variant="contained"
                            onClick={() => handleDownloadLastInvoice()}
                          >
                            Descargar factura
                          </Button>
                        )}

                        {stateForm.state === 'Entregado' && !stateForm.hasInvoice && (
                          <FileInputModal
                            formTitle={`Factura del pedido ${orderNumber}/${level}`}
                            buttonSize="medium"
                            modalButtonTitle="Añadir factura"
                            uploadFile={handleUploadFile}
                          />
                        )}

                        <Button
                          disabled={loading}
                          variant="contained"
                          onClick={handleClose}
                          className="ml-2"
                        >
                          CANCELAR
                        </Button>
                      </Grid>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        open={isEmptyOrderModalOpen}
        onClose={handleCloseEmptyOrderModal}
        maxWidth={'sm'}
        fullWidth={true}
      >
        <DialogContent>
          <div className="text-center">
            <AccessTime fontSize="large" className="mb-2" />
            <h4 className="font-weight-bold">El pedido todavía no se encuentra en el sistema.</h4>
            <h5>Por favor, vuelva a consultarlo en unos minutos.</h5>
            <SaveOrCancelButtons onCancel={handleCloseEmptyOrderModal} cancelLabel="Ok" />
          </div>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AcceptOrder
        open={isModalAcceptOpen}
        orderNumber={orderNumber}
        level={level}
        onCancel={() => setIsModalAcceptOpen(false)}
        onSave={handleClose}
      />
    </div>
  )
}

OrderDetails.defaultProps = {
  deliveryOrder: false
}
export default OrderDetails
